import { Component, ViewChild, ViewContainerRef, ElementRef, OnInit, TemplateRef} from '@angular/core';
import { AuthService } from 'app/services/auth.service';
import { UserInterfaceRQT } from 'app/models/user-interfaceRQT';
import { UserInterfaceToken } from 'app/models/user-interfaceToken';
import { UserInterfaceRPT } from 'app/models/user-interfaceRPT';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { switchMap } from "rxjs/operators"

import { isError } from 'util';
import { NgForm } from '@angular/forms/src/directives/ng_form';
import { LoginRQT } from 'app/models/user-LoginRQT';
import { LoginToken } from 'app/models/user-LoginToken';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { MatDialog, MatDialogConfig} from '@angular/material';
import { SuscripComponent } from '../appviews/suscrip.component';
import {SwAlert} from 'app/models/swalert';
import { NgxSpinnerService } from "ngx-spinner";
import swal from 'sweetalert';
import 'sweetalert2';
import Swal from 'sweetalert2';
import { Notificaciones } from 'app/models/notificacion';
import { ReportService } from 'app/services/report.service';
import { actContraseniaRQT} from 'app/models/user_actContraseniaRQT';
import { actContraseniaRPT} from 'app/models/user_actContraseniaRPT';


import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'autologin',
    templateUrl: 'autologin.template.html',
    styleUrls: ['autologin.component.css']
  })

export class AutoLoginComponent implements OnInit {

    modalRef: BsModalRef;
    tycObj:any;
    notify:any;
    public lista : number;
    public contraseniamod : any;

    RecObj : LoginRQT = {
        User: '',
        Password: '',
        Ip: '',
        Hostname: '',
        App: '',
        TipEnvio: ''
    }

    constructor(private authService: AuthService, private modalService: BsModalService, private dialog : MatDialog,
    private dialogc : MatDialog, private router: Router, private location: Location, private spinner: NgxSpinnerService, private reportService : ReportService, 
    private formBuilder: FormBuilder, private route: ActivatedRoute) 
    { }
  
    private actContra: actContraseniaRQT = {
        IDUser: 0,
        OldPass: '',
        NewPass: ''
    };

    public isError = false;
    public isNoError = true;
    public errorgen = true;
    public errormsj = ''; 

    private respactContra: actContraseniaRPT = {
        Cod : -1,
        Msj: ''
    };
  
    submitted = false;

    public user: UserInterfaceRQT = {
        Usuario: '',
        Password: ''
    };

    public usertoken: UserInterfaceToken = {
        Token: ''
    };
    

    public UserRPT :UserInterfaceRPT = null;
    public LNotif : Notificaciones;
    public notific: any;
    public notific1: any;

    public swmodal : SwAlert = {
    title : '',
    html : '',
    width : 0,
    confirmButtonText : "Aceptar"
    }
  
    private login: LoginToken = {
        Token: ''
    };
    public e:any;
    steps = [];
    notifys = [];
    notificaciones = [];

    token: string;

    ngOnInit() {
           
        localStorage.removeItem('NombreUsuario');   
        localStorage.removeItem('DireccionIP');               
        this.authService.getIp();     
        
        this.route.params.subscribe(routeParams => {
            this.token = routeParams.token;
        }); 
        
        this.onLogin();
    }

    onCreate(){
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        //dialogConfig.width = "40%";
        this.dialog.open(SuscripComponent, dialogConfig);      
    }
    
    onLogin() {

     
        var token = this.token;

        this.login.Token = token;
        
        this.authService.tokenusuario(this.login).subscribe(data => {
            this.UserRPT = data;   
            console.log("Datos Accesos : " + JSON.stringify(data));
            if (this.UserRPT.IDMsj == 0) {
            localStorage.setItem("Usuario", this.UserRPT.UsuaCodigo.toString());
            localStorage.setItem("NombreUsuario", this.UserRPT.UsuaNombres);
            localStorage.setItem("RolEmpUsuaCodigoDefault", this.UserRPT.RolEmpUsuaCodigoDefault.toString());
            localStorage.setItem("EntiNombre", this.UserRPT.EntiNombre);
            localStorage.setItem("ListaRol",JSON.stringify(this.UserRPT.listRol));
            localStorage.setItem("EntiCodigo", this.UserRPT.EntiCodigo);
            localStorage.setItem("NombreIniciales", this.UserRPT.UsuaInicial);
            localStorage.setItem("tiemposesion", this.UserRPT.TiempoEspera);
            localStorage.setItem("Menu",JSON.stringify(this.UserRPT.Menu));
            localStorage.setItem("Graficos",JSON.stringify(this.UserRPT.Dashboards.Data));
            localStorage.setItem("accessToken", this.UserRPT.Token);
                            
                        
            localStorage.setItem("CambiaContrasenia","0");    

            
            this.authService.getNotificaciones().subscribe(
                data => {                
                this.LNotif = data;          
                if (this.LNotif.Data != null)
                {                            
                    let listanotif =JSON.parse(JSON.stringify(this.LNotif.Data));
                    for (var i = 0; i <= listanotif.length-1; i++) {                    
                    let notifi = listanotif[i]; 
                    let modal = new SwAlert( 
                    "Notificacion " + (i + 1).toString(),
                    `<div class="form-control" style="overflow-y: scroll; height:400px; text-align: justify;">` + notifi.Aviso + "</div>",
                        500
                    )
                    this.notificaciones.push(modal);                  
                    }
                    Swal.queue(this.notificaciones);
                }                         
                },  
                error => {
                this.onIsError();           
                console.log("Error");}
                );
            this.router.navigate(['/dashboards/dashboardglobal']);
            }
            else{
            localStorage.removeItem('NombreUsuario');   
            localStorage.removeItem('DireccionIP');           
            localStorage.removeItem("NombreIniciales");
            this.onIsError();   
            }
        },  
        error => {
            this.onIsError();           
            console.log("Error");
        }
        );
        
    }

    onIsError(): void {
        this.isError = true;
        this.isNoError = false;
        window.location.href = 'https://www.meridian.com.pe/corporativo/accesounificado/?empresa=contrans';
        // setTimeout(() => {
        //     this.isError = false;
        // }, 4000);
    }
}